import React, { useState, useEffect } from 'react';
import {
  TextField,
  InputAdornment,
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Paper,
  Avatar,
  Pagination,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  Visibility,
  Code,
  Psychology,
  Group,
  Person,
  Work,
  Feedback,
  SmartToy,
  Download,
  Search,
  FilterList,
  MailOutline,
  AssignmentTurnedIn,
} from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


function JobInterviewHistory() {
  const [interviews, setInterviews] = useState([]);
  const INTERVIEWS_PER_PAGE = 10;
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedApp, setSelectedApp] = useState(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);



  // --- ADDED STATE (DO NOT REMOVE) ---
  const [aiCodingData, setAiCodingData] = useState(null);
  const [aiDataLoading, setAiDataLoading] = useState(false);
  const [aiTechnicalData, setAiTechnicalData] = useState(null);
  const [aiHrData, setAiHrData] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');

  const getStatusBadgeProps = (status) => {
    const s = (status || '').toLowerCase();

    if (s.includes('pending')) return { label: 'Pending', color: '#f57f17', bgcolor: '#fff8e1', border: '#ffe082' };
    if (s.includes('shortlisted')) return { label: 'Shortlisted', color: '#1976d2', bgcolor: '#e3f2fd', border: '#bbdefb' };
    if (s.includes('selected')) return { label: 'Selected', color: '#2e7d32', bgcolor: '#e8f5e9', border: '#c8e6c9' };
    if (s.includes('rejected')) return { label: 'Rejected', color: '#d32f2f', bgcolor: '#ffebee', border: '#ffcdd2' };
    if (s.includes('terminated')) return { label: 'Terminated', color: '#d32f2f', bgcolor: '#ffebee', border: '#ffcdd2' };
    if (s.includes('ai_technical_interview_completed')) return { label: 'AI Technical Interview Completed', color: '#4338CA', bgcolor: '#e0f2f1', border: '#b2dfdb' };
    if (s.includes('technical_l2_interview_completed')) return { label: 'Technical L2 Interview Completed', color: '#4338CA', bgcolor: '#e0f2f1', border: '#b2dfdb' };
    if (s.includes('ai_hr_interview_completed')) return { label: 'AI HR Interview Completed', color: '#4338CA', bgcolor: '#e0f2f1', border: '#b2dfdb' };
    if (s.includes('hr_l2_interview_completed')) return { label: 'HR L2 Interview Completed', color: '#4338CA', bgcolor: '#e0f2f1', border: '#b2dfdb' };
    if (s.includes('completed')) return { label: 'Completed', color: '#4338CA', bgcolor: '#e0f2f1', border: '#b2dfdb' };
    if (s === 'ai_coding_scheduled') return { label: 'AI Coding Assessment Scheduled', color: '#b7791f', bgcolor: '#fffff0', border: '#f6e05e' };
    if (s.includes('ai_technical_interview_scheduled')) return { label: 'AI Technical Interview Scheduled', color: '#1976d2', bgcolor: '#e3f2fd', border: '#bbdefb' };
    if (s.includes('technical_l2_interview_scheduled')) return { label: 'Technical L2 Interview Scheduled', color: '#1976d2', bgcolor: '#e3f2fd', border: '#bbdefb' };
    if (s.includes('ai_hr_interview_scheduled')) return { label: 'AI HR Interview Scheduled', color: '#7b1fa2', bgcolor: '#f3e5f5', border: '#ce93d8' };
    if (s.includes('hr_l2_interview_scheduled')) return { label: 'HR L2 Interview Scheduled', color: '#7b1fa2', bgcolor: '#f3e5f5', border: '#ce93d8' };
    if (s.includes('scheduled')) return { label: 'Interview Scheduled', color: '#1976d2', bgcolor: '#e3f2fd', border: '#bbdefb' };
    if (s.includes('technical_cancelled')) {
      return {
        label: 'Technical Cancelled',
        color: '#616161',
        bgcolor: '#f5f5f5',
        border: '#e0e0e0'
      };
    }

    if (s.includes('hr_cancelled')) {
      return {
        label: 'HR Cancelled',
        color: '#616161',
        bgcolor: '#f5f5f5',
        border: '#e0e0e0'
      };
    }

    if (s.includes('offer_released') || s.includes('offer released')) {
      return {
        label: 'Offer Released',
        color: '#2e7d32',
        bgcolor: '#e8f5e9',
        border: '#c8e6c9'
      };
    }

    if (s.includes('technical interview') || s.includes('technical_interview')) {
        return {
          label: 'Technical Interview',
          color: '#1976d2',
          bgcolor: '#e3f2fd',
          border: '#bbdefb'
        };
    }

    if (s.includes('hr scheduled') || s.includes('hr_scheduled')) {
        return {
          label: 'HR Scheduled',
          color: '#1976d2',
          bgcolor: '#e3f2fd',
          border: '#bbdefb'
        };
    }

    return { label: status || 'Pending', color: '#616161', bgcolor: '#f5f5f5', border: '#e0e0e0' };
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterSelect = (status) => {
    setStatusFilter(status);
    handleFilterClose();
    setPage(1);
  };

  const getAvatarColor = (name) => {
    const colors = ['#26a69a', '#26c6da', '#42a5f5', '#7e57c2', '#ef5350', '#ffa726'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  };

  const getStageLabel = (status) => {
    if (!status) return "Application";
    if (status === "ai_coding_scheduled") return "AI Coding Assessment Scheduled";

    const formatted = status
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    return formatted
      .replace("Hr", "HR")
      .replace("Ai", "AI");
  };
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const getLabel = (type) => {
    const labels = {
      tabSwitch: "Tab switch",
      faceMissing: "Face missing",
      multipleFaces: "Multiple faces",
      noFaceDetected: "Face not visible",
      eyeGazeAway: "Eye gaze away",
      backgroundVoice: "Background voice",
      deviceChange: "Device change",
      ipChange: "IP change",
      vpnDetected: "VPN usage"
    };
    return labels[type] || type;
  };

  const handleJump = (time) => {
    console.log("Jumping to time:", time);
    // Future: Implement replay jump logic
  };

  const getSeverityColor = (type) => {
    const map = {
      vpnDetected: "#d32f2f",        // critical (red)
      backgroundVoice: "#d32f2f",
      multipleFaces: "#d32f2f",

      tabSwitch: "#f57c00",          // medium (orange)
      faceMissing: "#f57c00",

      eyeGazeAway: "#fbc02d"         // low (yellow)
    };
    return map[type] || "#333";
  };

  const getSeverityLabel = (type) => {
    if (["vpnDetected", "backgroundVoice", "multipleFaces"].includes(type)) return "Critical";
    if (["tabSwitch", "faceMissing"].includes(type)) return "Warning";
    return "Low";
  };

  useEffect(() => {
    async function fetchHistory() {
      try {
        const token = localStorage.getItem("token");

        const response = await axios({
          method: "GET",
          url: "https://api.exihire.com/applications/admin/interview-history",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        // 🔍 DEBUG (must keep)
        console.log("RAW RESPONSE:", response);
        console.log("RESPONSE DATA:", response.data);

        // ✅ SAFE PARSING (fix)
        const data =
          Array.isArray(response.data)
            ? response.data
            : response.data?.data ||
              response.data?.applications ||
              [];

        setInterviews(data);
      } catch (error) {
        console.error('Failed to fetch interview history:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchHistory();
  }, []);

  useEffect(() => {
    if (loading) return;
    const appId = searchParams.get('applicationId');
    if (!appId) return;
    const matched = interviews.find(app => String(app.id) === String(appId));
    if (matched) {
      handleOpenDetails(matched);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

const handleDownloadPDF = async () => {
  const source = document.getElementById('pdf-print-template');
  if (!source) return;

 // Clone the visible report offscreen so UI is not affected
   const clone = source.cloneNode(true);
   clone.querySelectorAll('.question-block').forEach(el => {
     el.style.pageBreakInside = 'avoid';
     el.style.breakInside = 'avoid';
   });
   clone.style.position = 'fixed';
   clone.style.left = '-10000px';
   clone.style.top = '0';
   clone.style.width = '750px';
   clone.style.background = 'white';
   clone.style.display = 'block';
   clone.style.overflow = 'visible';
   document.body.appendChild(clone);

   try {
       await new Promise((resolve) => setTimeout(resolve, 50));

    const canvas = await html2canvas(clone, {
         scale: 2,
         useCORS: true,
         backgroundColor: '#ffffff',
         windowWidth: clone.scrollWidth,
         windowHeight: clone.scrollHeight,
       });

    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    const pdf = new jsPDF('p', 'mm', 'a4');

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;

     const imgWidth = pdfWidth - margin * 2;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const pageHeight = pdfHeight - margin * 2;

        let y = 0;

        while (y < canvas.height) {
          const pageCanvas = document.createElement('canvas');

          pageCanvas.width = canvas.width;
          pageCanvas.height = Math.min(
            canvas.width * 1.35,
            canvas.height - y
          );

          const ctx = pageCanvas.getContext('2d');

          ctx.drawImage(
            canvas,
            0,
            y,
            canvas.width,
            pageCanvas.height,
            0,
            0,
            canvas.width,
            pageCanvas.height
          );

          const pageImg = pageCanvas.toDataURL('image/jpeg', 1.0);

          if (y > 0) pdf.addPage();

          pdf.addImage(
            pageImg,
            'JPEG',
            margin,
            margin,
            imgWidth,
            (pageCanvas.height * imgWidth) / pageCanvas.width
          );

          y += pageCanvas.height;
        }

    pdf.save(`Official_Report_${selectedApp?.first_name}.pdf`);
  } catch (error) {
    console.error("PDF Error:", error);
  } finally {
    document.body.removeChild(clone);
  }
};
  // --- UPDATED HANDLER (DO NOT REMOVE EXISTING LOGIC) ---
  const handleOpenDetails = async (app) => {
    setSelectedApp(app);
    setDetailsDialogOpen(true);

    // Reset all data sources
    setAiCodingData(null);
    setAiTechnicalData(null);
    setAiHrData(null);
    setAiDataLoading(true);

    const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

    // Fetch AI Coding interview result (from ai_interview_results)
    try {
      const res = await axios.get(`https://api.exihire.com/ai-interview/result/${app.id}`, { headers: authHeader });
      const data = res.data?.data || res.data;
      if (data) setAiCodingData(data);
    } catch (err) {
      console.warn("AI Coding data fetch failed:", err?.response?.status);
    }

    // Fetch AI Technical interview result (from technical_interviews)
    try {
      const res = await axios.get(`https://api.exihire.com/assessments/technical-interview/result/${app.id}`, { headers: authHeader });
      const data = res.data?.data || res.data;
      if (data) setAiTechnicalData(data);
    } catch (err) {
      if (err?.response?.status !== 404) console.warn("AI Technical data fetch failed:", err?.response?.status);
    }

    // Fetch AI HR interview result (from hr_interviews)
    try {
      const res = await axios.get(`https://api.exihire.com/assessments/hr-interview/result/${app.id}`, { headers: authHeader });
      const data = res.data?.data || res.data;
      if (data) setAiHrData(data);
    } catch (err) {
      if (err?.response?.status !== 404) console.warn("AI HR data fetch failed:", err?.response?.status);
    }

    setAiDataLoading(false);
  };

  const handleCloseDetails = () => {
    setDetailsDialogOpen(false);
    setSelectedApp(null);
    setAiCodingData(null);
    setAiTechnicalData(null);
    setAiHrData(null);
    setAiDataLoading(false);
  };

  if (loading) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
          <CircularProgress />
        </Box>
    );
  }

  const getStatusColor = (status) => {
    const s = (status || '').toLowerCase();
    if (s.includes('completed')) return 'success';
    if (s.includes('scheduled')) return 'info';
    if (s === 'terminated') return 'error';
    if (s === 'pending') return 'warning';
    if (s === 'shortlisted') return 'info';
    if (s === 'rejected') return 'error';
    if (s === 'offered') return 'success';
    return 'default';
  };

  const parseAIFeedback = (notes) => {
    if (!notes) return null;
    try {
      return JSON.parse(notes);
    } catch (e) {
      return { detailedFeedback: notes };
    }
  };
const renderPDFTemplate = () => {
  if (!aiCodingData) return null;
  let answers = [];
  try {
    answers = typeof aiCodingData.answers === 'string'
      ? JSON.parse(aiCodingData.answers)
      : aiCodingData.answers || [];
  } catch (e) { console.error(e); }

  return (
    <Box
      id="pdf-print-template"
      sx={{
        position: 'fixed',
        left: '-99999px',
        top: 0,
        width: '750px',
        bgcolor: 'white',
        p: 4,
        zIndex: -1
      }}
    >

      {/* SECTION 1: HEADER & SUMMARY (Wrapped in pdf-header-section class) */}
      <Box className="pdf-header-section">
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ color: '#4F46E5', mb: 0.5 }}>
            INTERVIEW PERFORMANCE REPORT
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Candidate: {selectedApp?.first_name} {selectedApp?.last_name} | Position: {selectedApp?.job_title}
          </Typography>
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="h6" sx={{
              color: 'white', bgcolor: '#4F46E5', display: 'inline-block',
              px: 3, py: 0.5, borderRadius: 1, fontWeight: 'bold', fontSize: '1rem'
            }}>
              OVERALL SCORE: {aiCodingData.score}%
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2, borderBottomWidth: 2, borderColor: '#4F46E5' }} />

        {(() => {
          const ev =
            typeof aiCodingData.evaluation_details === 'string'
              ? JSON.parse(aiCodingData.evaluation_details || '{}')
              : aiCodingData.evaluation_details;

          if (!ev) return null;

          return (
            <>
              {/* OVERALL SCORE */}
              <Paper sx={{ p: 2, mb: 2 }}>
                <Typography fontWeight="bold">
                  Overall AI Performance
                </Typography>

                <Typography variant="h3">
                  {ev.finalScore || aiCodingData.score}/100
                </Typography>
              </Paper>

              {/* SCORE BREAKDOWN */}
              <Paper sx={{ p: 2, mb: 2 }}>
                <Typography fontWeight="bold">
                  Score Breakdown
                </Typography>

                <Typography>
                  Q&A / Communication :
                  {ev.componentScores?.qa || 0}%
                </Typography>

                <Typography>
                  Participation :
                  {ev.componentScores?.participation || 0}%
                </Typography>

                <Typography>
                  Integrity / Proctoring :
                  {ev.componentScores?.proctoring || 0}%
                </Typography>
              </Paper>

              {/* QUESTION COMPLETION */}
              {ev.participationEvaluation && (
                <Paper sx={{ p: 2, mb: 2 }}>
                  <Typography fontWeight="bold">
                    Question Completion
                  </Typography>

                  <Typography>
                    Questions Answered :
                    {ev.participationEvaluation.questionsAnswered}
                    /
                    {ev.participationEvaluation.totalQuestions}
                  </Typography>

                  <Typography>
                    Completion Rate :
                    {ev.participationEvaluation.completionRate}%
                  </Typography>
                </Paper>
              )}

              {/* Q&A EVALUATION */}
              {ev.qaEvaluation && (
                <Paper sx={{ p: 2, mb: 2 }}>
                  <Typography fontWeight="bold">
                    Q&A Evaluation
                  </Typography>

                  <Typography>
                    Accuracy :
                    {ev.qaEvaluation.accuracyScore}%
                  </Typography>

                  <Typography>
                    Communication :
                    {ev.qaEvaluation.communicationScore}%
                  </Typography>

                  <Typography>
                    Technical Depth :
                    {ev.qaEvaluation.technicalDepthScore}%
                  </Typography>
                </Paper>
              )}
            </>
          );
        })()}

        {/* ASSESSMENT SUMMARY */}
        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#4F46E5', mb: 1 }}>
          ASSESSMENT SUMMARY
        </Typography>
        <Paper variant="outlined" sx={{ p: 2, mb: 3, bgcolor: '#F8FAFC', borderLeft: '8px solid #4F46E5', borderRadius: 1 }}>
          <Typography variant="body2" sx={{ fontSize: '0.85rem', lineHeight: 1.4, color: '#333', textTransform: 'none' }}>
            {(() => {
              let f = aiCodingData.feedback || "Assessment data processed successfully.";
              return f.replace(/^TERMINATED:\s*/i, '');
            })()}
          </Typography>
        </Paper>

        {/* Behavioral Analysis Section for PDF */}
        {aiCodingData.behavior_summary && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              bgcolor: '#f4f8ff',
              borderRadius: 1,
              border: '1px solid #d1e3ff',
              borderLeft: '6px solid #1976d2'
            }}
          >
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: '#1976d2',
                textTransform: 'none',
                letterSpacing: '0.5px',
                mb: 1
              }}
            >
              Behavioral Analysis:
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: 'text.primary',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 1
              }}
            >
              <strong>Confidence:</strong> {(() => {
                const summary = typeof aiCodingData.behavior_summary === 'string'
                  ? JSON.parse(aiCodingData.behavior_summary)
                  : aiCodingData.behavior_summary;
                return summary.confidence || 'N/A';
              })()}
            </Typography>

            {(() => {
              const summary = typeof aiCodingData.behavior_summary === 'string'
                ? JSON.parse(aiCodingData.behavior_summary)
                : aiCodingData.behavior_summary;
              const observations = summary.observations || [];
              if (observations.length === 0) return null;
              return observations.map((obs, i) => (
                <Typography key={i} variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  • {obs}
                </Typography>
              ));
            })()}
          </Box>
        )}

        {/* Trust Assessment Section for PDF */}
        {aiCodingData.trust_score !== undefined && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              bgcolor: aiCodingData.risk_level === 'LOW' ? '#d4edda20' : aiCodingData.risk_level === 'MEDIUM' ? '#fff3cd20' : '#f8d7da20',
              borderRadius: 1,
              border: `1px solid ${aiCodingData.risk_level === 'LOW' ? '#d4edda' : aiCodingData.risk_level === 'MEDIUM' ? '#fff3cd' : '#f8d7da'}`,
              borderLeft: `6px solid ${aiCodingData.risk_level === 'LOW' ? '#28a745' : aiCodingData.risk_level === 'MEDIUM' ? '#ffc107' : '#dc3545'}`
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold" sx={{ color: aiCodingData.risk_level === 'LOW' ? '#155724' : aiCodingData.risk_level === 'MEDIUM' ? '#856404' : '#721c24', mb: 1 }}>
              Trust Assessment:
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
             <strong>{(aiCodingData.risk_level || 'LOW').toUpperCase()} RISK</strong>
              {(() => {
                let allViolations = [];

                try {
                  const v = typeof aiCodingData.violations === "string"
                    ? JSON.parse(aiCodingData.violations)
                    : aiCodingData.violations || {};

                  allViolations = Object.entries(v)
                    .filter(([_, count]) => count > 0)
                    .map(([key]) => getLabel(key));

                } catch (e) {
                  console.error("Violation parse error", e);
                }

                return allViolations.length > 0
                  ? ` – ${allViolations.join(", ")}`
                  : "";
              })()}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              Trust Score: {aiCodingData.trust_score}%
            </Typography>
          </Box>
        )}

        {/* Suspicious Activity Timeline for PDF */}
        {aiCodingData.violation_events && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              borderRadius: "10px"
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#333', mb: 1 }}>
              Suspicious Activity Timeline
            </Typography>
            {(() => {
              const events = aiCodingData.violation_events || [];
              if (events.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary">
                    No suspicious activity detected.
                  </Typography>
                );
              }
              return events.map((event, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                    p: 1.2,
                    borderRadius: "6px",
                    backgroundColor: "#ffffff",
                    border: "1px solid #f0f0f0"
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary', minWidth: '50px' }}>
                      [{formatTime(event.time)}]
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 2,
                        color: getSeverityColor(event.type),
                        fontWeight: 500
                      }}
                    >
                      {getLabel(event.type)}
                    </Typography>
                  </Box>
                  <Chip
                    label={getSeverityLabel(event.type)}
                    size="small"
                    sx={{
                      ml: 1,
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      backgroundColor: `${getSeverityColor(event.type)}15`,
                      color: getSeverityColor(event.type),
                      border: `1px solid ${getSeverityColor(event.type)}30`,
                    }}
                  />
                </Box>
              ));
            })()}
          </Box>
        )}

        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#4F46E5', mb: 1.5 }}>
          INTERVIEW TRANSCRIPT
        </Typography>
      </Box>

      {/* SECTION 2: TRANSCRIPT QUESTIONS (Each wrapped in question-block class) */}
      {answers.map((item, index) => (
        <Box
          key={index}
          className="question-block"
          sx={{
            pageBreakInside: 'avoid',
            breakInside: 'avoid',
            WebkitColumnBreakInside: 'avoid',
            mb: 2,
            p: 2,
            bgcolor: '#f9f9f9',
            border: '1px solid #ddd',
            borderRadius: 1,
            display: 'block'
          }}
        >
          <Typography variant="body2" fontWeight="bold" color="#4F46E5" sx={{ textTransform: 'none', mb: 1, fontSize: '0.9rem' }}>
            Question {index + 1}: {item.question}
          </Typography>
          <Box sx={{ p: 1, bgcolor: 'white', borderRadius: 0.5, border: '1px solid #eee' }}>
            {item.questionType === 'architecture' ? (
              <>
                <Typography variant="body2" sx={{ textTransform: 'none', fontSize: '0.8rem', mb: 1 }}>
                  <strong>Type:</strong> Architecture Design
                </Typography>
                {(() => {
                  const img = item.canvasData?.canvasImage || aiCodingData?.architecture_canvas?.canvasImage;
                  if (img) return <Box component="img" src={img} alt="Architecture Drawing" sx={{ width: '100%', maxWidth: 500, display: 'block', borderRadius: 0.5, border: '1px solid #ddd', mb: 1 }} />;
                  const count = item.canvasData?.shapes?.length || aiCodingData?.architecture_canvas?.shapes?.length || 0;
                  return <Typography variant="body2" sx={{ textTransform: 'none', fontSize: '0.8rem', color: '#666' }}>Architecture drawing submitted ({count} elements)</Typography>;
                })()}
              </>
            ) : item.questionType === 'coding' ? (
              (() => {
                const isFrontend = /html\/css|html|frontend/i.test(item.selectedLanguage || '');
                const src = item.sourceCode || item.answer || item.response || '';
                if (isFrontend) {
                  const htmlMatch = src.match(/<!--\s*HTML\s*-->\n([\s\S]*?)(?=\n\s*\/\*\s*CSS|$)/);
                  const cssMatch  = src.match(/\/\*\s*CSS\s*\*\/\n([\s\S]*)/);
                  const htmlCode  = htmlMatch ? htmlMatch[1].trim() : src;
                  const cssCode   = cssMatch  ? cssMatch[1].trim()  : '';
                  return (
                    <>
                      <Typography variant="body2" sx={{ textTransform: 'none', fontFamily: 'monospace', fontSize: '0.8rem', mb: 1 }}>
                        <strong>Language:</strong> HTML/CSS (Frontend)
                      </Typography>
                      {htmlCode && (
                        <>
                          <Typography variant="body2" sx={{ textTransform: 'none', fontFamily: 'monospace', fontSize: '0.8rem', color: '#e34c26', fontWeight: 700 }}>HTML:</Typography>
                          <Box sx={{ p: 1, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 0.5, mb: 1, overflowX: 'auto' }}>
                            <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>{htmlCode}</pre>
                          </Box>
                        </>
                      )}
                      {cssCode && (
                        <>
                          <Typography variant="body2" sx={{ textTransform: 'none', fontFamily: 'monospace', fontSize: '0.8rem', color: '#264de4', fontWeight: 700 }}>CSS:</Typography>
                          <Box sx={{ p: 1, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 0.5, mb: 1, overflowX: 'auto' }}>
                            <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>{cssCode}</pre>
                          </Box>
                        </>
                      )}
                    </>
                  );
                }
                return (
                  <>
                    <Typography variant="body2" sx={{ textTransform: 'none', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8rem', mb: 1 }}>
                      <strong>Language:</strong> {item.selectedLanguage || 'Unknown'}
                    </Typography>
                    <Typography variant="body2" sx={{ textTransform: 'none', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                      <strong>Code:</strong>
                    </Typography>
                    <Box sx={{ p: 1, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 0.5, mb: 1, overflowX: 'auto' }}>
                      <pre style={{ margin: 0, fontSize: '0.75rem' }}>{src}</pre>
                    </Box>
                    {(item.executionOutput || item.compileError || item.runtimeError || item.terminalOutput || item.executionStatus || item.sqlResult) && (
                      <>
                        <Typography variant="body2" sx={{ textTransform: 'none', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                          <strong>Terminal Output:</strong>
                        </Typography>
                        <Box sx={{ p: 1, bgcolor: '#000', color: '#00ff00', borderRadius: 0.5, mb: 1, maxHeight: '250px', overflowY: 'auto' }}>
                          <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>
                            {item.terminalOutput || (
                              <>
                                {item.compileError && `Compilation failed:\n${item.compileError}\n\n`}
                                {item.runtimeError && `Runtime Error:\n${item.runtimeError}\n\n`}
                                {item.executionOutput && `${item.executionOutput}\n`}
                              </>
                            )}
                          </pre>
                          {item.sqlResult && (
                            <Box sx={{ mt: 2, bgcolor: '#fff', color: '#000', p: 1, borderRadius: 0.5 }}>
                              <Typography variant="subtitle2" sx={{ mb: 1, color: '#000', fontWeight: 'bold' }}>
                                SQL Output Table:
                              </Typography>
                              {item.sqlResult.rows && item.sqlResult.rows.length > 0 ? (
                                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 300, mb: 1, overflow: 'auto' }}>
                                  <Table size="small" stickyHeader>
                                    <TableHead>
                                      <TableRow>
                                        {(item.sqlResult.columns || []).map((col) => (
                                          <TableCell key={col} sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5', whiteSpace: 'nowrap' }}>{col}</TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {item.sqlResult.rows.map((row, idx) => (
                                        <TableRow key={idx}>
                                          {(item.sqlResult.columns || []).map((col) => (
                                            <TableCell key={col}>{row[col]}</TableCell>
                                          ))}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                <Typography variant="body2" sx={{ mb: 1, color: '#666', fontStyle: 'italic' }}>No rows returned.</Typography>
                              )}

                              <Typography variant="body2" sx={{ mb: 2, color: '#000' }}>
                                <strong>Rows Returned:</strong> {item.sqlResult.rowCount || 0}
                              </Typography>

                              {item.sqlResult.expectedOutput && (
                                <Box sx={{ mb: 2 }}>
                                  <Typography variant="subtitle2" sx={{ mb: 0.5, color: '#000', fontWeight: 'bold' }}>
                                    Expected Output Table:
                                  </Typography>
                                  <Box sx={{ p: 1, bgcolor: '#f9f9f9', border: '1px solid #ddd', borderRadius: 0.5 }}>
                                    <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap', color: '#333', fontFamily: 'monospace' }}>
                                      {item.sqlResult.expectedOutput}
                                    </pre>
                                  </Box>
                                </Box>
                              )}

                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Typography variant="subtitle2" sx={{ color: '#000', fontWeight: 'bold' }}>Output Match:</Typography>
                                <Chip
                                  label={item.sqlResult.matchStatus || (item.testCaseSummary?.thresholdMet ? 'PASSED' : 'FAILED')}
                                  size="small"
                                  sx={{
                                    height: 20,
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold',
                                    bgcolor: (item.sqlResult.matchStatus === 'PASSED' || item.testCaseSummary?.thresholdMet) ? '#e6ffed' : '#ffeef0',
                                    color: (item.sqlResult.matchStatus === 'PASSED' || item.testCaseSummary?.thresholdMet) ? '#22863a' : '#cf222e',
                                    border: `1px solid ${(item.sqlResult.matchStatus === 'PASSED' || item.testCaseSummary?.thresholdMet) ? '#22863a' : '#cf222e'}`
                                  }}
                                />
                              </Box>

                              {/* Hidden test case evaluation results */}
                              {item.sqlResult.hiddenTestsPassed !== undefined && (
                                <Box sx={{ mt: 1, p: 1, bgcolor: '#f0f4ff', border: '1px solid #c7d2fe', borderRadius: 0.5 }}>
                                  <Typography variant="subtitle2" sx={{ color: '#1e40af', fontWeight: 'bold', mb: 0.5 }}>
                                    Hidden Test Cases: {item.sqlResult.hiddenTestsPassed}/{item.sqlResult.hiddenTestsTotal} Passed
                                  </Typography>
                                  {item.sqlResult.tierScore !== undefined && (
                                    <Typography variant="body2" sx={{ color: '#1e40af', mb: 0.5 }}>
                                      <strong>SQL Score:</strong> {item.sqlResult.tierScore}/100
                                    </Typography>
                                  )}
                                  {Array.isArray(item.sqlResult.feedback) && item.sqlResult.feedback.length > 0 && (
                                    <Box>
                                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 'bold', mb: 0.25 }}>Evaluation Feedback:</Typography>
                                      {item.sqlResult.feedback.map((msg, i) => (
                                        <Typography key={i} variant="body2" sx={{ color: '#4b5563', fontSize: '0.75rem' }}>• {msg}</Typography>
                                      ))}
                                    </Box>
                                  )}
                                </Box>
                              )}
                            </Box>
                          )}
                        </Box>
                        <Typography variant="body2" sx={{ textTransform: 'none', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                          <strong>Status:</strong> {item.executionStatus === 'success' ? 'Execution Successful' : item.executionStatus === 'compile_error' ? 'Compilation Failed' : item.executionStatus === 'runtime_error' ? 'Runtime Error' : item.executionStatus === 'not_executed' ? 'Not Executed' : item.executionStatus || 'Unknown'}
                        </Typography>
                      </>
                    )}
                  </>
                );
              })()
            ) : (
              <Typography variant="body2" sx={{ textTransform: 'none', whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>
                {item.answer || item.response || 'No response recorded'}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

// --- UPDATED RENDER FUNCTION ---
const renderAiTranscriptSection = (reportData = aiCodingData, sectionTitle = null) => {
   // eslint-disable-next-line no-shadow
   const aiCodingData = reportData; // allows callers to pass override data; all existing refs below use this local alias
   if (!aiCodingData || Object.keys(aiCodingData).length === 0) {
     return null;
   }

   const isTerminated = (
     aiCodingData.status === 'TERMINATED' ||
     (aiCodingData.feedback && aiCodingData.feedback.toLowerCase().includes("terminated")) ||
     selectedApp?.status?.toLowerCase() === 'terminated'
   );

   const hasScore = !isTerminated && aiCodingData.score !== null && aiCodingData.score !== undefined;

   // 2. Parse answers safely
   let answers = [];
   try {
     answers = typeof aiCodingData.answers === 'string'
       ? JSON.parse(aiCodingData.answers)
       : aiCodingData.answers || [];
   } catch (e) {
     console.error("Error parsing answers:", e);
   }

   return (
     <>
       {sectionTitle && (
         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, mt: 0.5 }}>
           <SmartToy sx={{ color: '#4F46E5', fontSize: 20 }} />
           <Typography variant="h6" fontWeight="bold" sx={{ color: '#1e293b' }}>{sectionTitle}</Typography>
         </Box>
       )}
     <Paper
       variant="outlined"
       sx={{
         p: 2,
         mb: 3,
         bgcolor: isTerminated ? '#fff5f5' : '#F8FAFC',
         borderLeft: `5px solid ${isTerminated ? '#f44336' : '#4F46E5'}`,
         borderRadius: 2
       }}
     >
       {/* Header Section */}
       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
         <Box sx={{ display: 'flex', alignItems: 'center' }}>
           <SmartToy sx={{ color: isTerminated ? '#f44336' : '#4F46E5', mr: 1 }} />
           <Typography variant="h6" fontWeight="bold" color={isTerminated ? '#f44336' : '#4F46E5'}>
             {isTerminated ? "AI Interview Terminated" : "AI Performance Report"}
           </Typography>
         </Box>

         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
           {hasScore && (
             <Chip
               label={`Score: ${aiCodingData.score}%`}
               color={aiCodingData.score >= 70 ? "success" : aiCodingData.score >= 40 ? "warning" : "error"}
               sx={{ fontWeight: 'bold', fontSize: '1rem' }}
             />
           )}

           {aiCodingData.trust_score !== undefined && (
             <Chip
               label={`Trust: ${aiCodingData.trust_score}% (${(aiCodingData.risk_level || 'LOW').charAt(0).toUpperCase() + (aiCodingData.risk_level || 'LOW').slice(1).toLowerCase()} Risk)`}
               sx={{
                 fontWeight: 'bold',
                 fontSize: '1rem',
                 bgcolor: aiCodingData.risk_level === 'LOW' ? '#d4edda' : aiCodingData.risk_level === 'MEDIUM' ? '#fff3cd' : '#f8d7da',
                 color: aiCodingData.risk_level === 'LOW' ? '#155724' : aiCodingData.risk_level === 'MEDIUM' ? '#856404' : '#721c24',
                 '& .MuiChip-label': { px: 1.5 }
               }}
             />
           )}
         </Box>
       </Box>

       <Divider sx={{ mb: 1.5 }} />

       {/* ─── ENHANCED AI PERFORMANCE SCORE BREAKDOWN ─── */}
       {(() => {
         const ev = (() => {
           try {
             return typeof aiCodingData.evaluation_details === 'string'
               ? JSON.parse(aiCodingData.evaluation_details)
               : aiCodingData.evaluation_details || null;
           } catch (e) { return null; }
         })();

         if (!ev) return null;

         const bandColor = ev.performanceColor || '#f59e0b';
         const bandLabel = ev.performanceBand || 'Moderate';

         const ScoreRow = ({ label, value, color }) => (
           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
             <Typography variant="body2" color="text.secondary" sx={{ minWidth: 160 }}>{label}</Typography>
             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, ml: 2 }}>
               <Box sx={{ flex: 1, height: 6, borderRadius: 3, bgcolor: '#e0e0e0', overflow: 'hidden' }}>
                 <Box sx={{ width: `${value ?? 0}%`, height: '100%', borderRadius: 3, bgcolor: color || bandColor, transition: 'width 0.4s ease' }} />
               </Box>
               <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 34, textAlign: 'right', color: color || bandColor }}>
                 {value ?? '—'}{value !== null && value !== undefined ? '%' : ''}
               </Typography>
             </Box>
           </Box>
         );

         return (
           <>
             {/* Overall Score Banner */}
             <Box sx={{ mb: 2, p: 2, borderRadius: 2, border: `2px solid ${bandColor}`, bgcolor: `${bandColor}10`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
               <Box>
                 <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
                   Overall AI Performance
                 </Typography>
                 <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                   <Typography variant="h3" fontWeight="bold" sx={{ color: bandColor, lineHeight: 1 }}>
                     {ev.finalScore ?? aiCodingData.score ?? 0}
                   </Typography>
                   <Typography variant="h6" color="text.secondary">/100</Typography>
                 </Box>
               </Box>
               <Chip label={bandLabel} size="medium" sx={{ fontWeight: 700, fontSize: '0.85rem', bgcolor: bandColor, color: '#fff', px: 1 }} />
             </Box>

             {/* Component Score Bars */}
             <Box sx={{ mb: 2, p: 2, bgcolor: '#fafafa', borderRadius: 2, border: '1px solid #e0e0e0' }}>
               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, color: '#444' }}>Score Breakdown</Typography>
               {ev.componentScores?.qa !== null && ev.componentScores?.qa !== undefined && (
                 <ScoreRow label="Q&A / Communication" value={ev.componentScores.qa} color="#1976d2" />
               )}
               {ev.componentScores?.coding !== null && ev.componentScores?.coding !== undefined && (
                 <ScoreRow label="Coding Assessment" value={ev.componentScores.coding} color="#7b1fa2" />
               )}

               {ev.componentScores?.architecture !== null && ev.componentScores?.architecture !== undefined && (
                 <ScoreRow label="Architecture Design" value={ev.componentScores.architecture} color="#2e7d32" />
               )}
               <ScoreRow label="Participation" value={ev.componentScores?.participation} color="#e65100" />
               <ScoreRow label="Integrity / Proctoring" value={ev.componentScores?.proctoring} color={aiCodingData.risk_level === 'LOW' ? '#2e7d32' : aiCodingData.risk_level === 'MEDIUM' ? '#f57c00' : '#c62828'} />
             </Box>

             {/* Question Completion */}
             {ev.participationEvaluation && (
               <Box sx={{ mb: 2, p: 2, bgcolor: '#fff8e1', borderRadius: 2, border: '1px solid #ffe082', borderLeft: '5px solid #f9a825' }}>
                 <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#e65100', mb: 1 }}>Question Completion</Typography>
                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                   {[
                     { label: 'Questions Answered', value: `${ev.participationEvaluation.questionsAnswered} / ${ev.participationEvaluation.totalQuestions}` },
                     { label: 'Completion Rate',    value: `${ev.participationEvaluation.completionRate}%` },
                     { label: 'Unanswered',         value: ev.participationEvaluation.unansweredQuestions },
                     { label: 'Terminated Midway',  value: ev.participationEvaluation.terminatedMidInterview ? 'Yes' : 'No' },
                     { label: 'Participation Score',value: `${ev.participationEvaluation.score}/100` },
                   ].map(item => (
                     <Box key={item.label} sx={{ minWidth: 130 }}>
                       <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                       <Typography variant="body2" fontWeight="bold">{item.value}</Typography>
                     </Box>
                   ))}
                 </Box>
               </Box>
             )}

             {/* Coding Assessment */}
             {ev.codingEvaluation && (
               <Box sx={{ mb: 2, p: 2, bgcolor: '#f3e5f5', borderRadius: 2, border: '1px solid #ce93d8', borderLeft: '5px solid #7b1fa2' }}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                   <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#7b1fa2' }}>Coding Assessment</Typography>
                   <Chip label={`Score: ${ev.codingEvaluation.score}/100`} size="small"
                     sx={{ fontWeight: 700, bgcolor: '#7b1fa2', color: '#fff', fontSize: '0.75rem' }} />
                 </Box>
                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                   {[
                     { label: 'Compilation',   value: ev.codingEvaluation.compilationStatus },
                     { label: 'Test Cases',    value: ev.codingEvaluation.totalTestCases > 0 ? `${ev.codingEvaluation.testCasesPassed} / ${ev.codingEvaluation.totalTestCases} Passed` : 'N/A' },
                     { label: 'Output Accuracy', value: ev.codingEvaluation.outputAccuracy !== null && ev.codingEvaluation.outputAccuracy !== undefined ? `${ev.codingEvaluation.outputAccuracy}%` : 'Evaluation Not Available' },
                     { label: 'Code Quality', value: ev.codingEvaluation.codeQualityLabel },
                   ].map(item => (
                     <Box key={item.label} sx={{ minWidth: 130 }}>
                       <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                       <Typography variant="body2" fontWeight="bold"
                         sx={{ color: item.label === 'Compilation' ? (item.value === 'Passed' ? '#2e7d32' : '#c62828') : 'inherit' }}>
                         {item.value}
                       </Typography>
                     </Box>
                   ))}
                 </Box>

                 {/* Per-question detailed breakdown — shows ALL coding questions */}
                 {(() => {
                   const codingAnswers = answers.filter(
                     a =>
                       a.questionType === 'coding' &&
                       (a.selectedLanguage || '').toLowerCase() !== 'sql'
                   );
                   const perQ = ev.codingEvaluation.perQuestionResults || [];
                   const count = Math.max(codingAnswers.length, perQ.length);
                   if (count === 0) return null;
                   return (
                     <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e1bee7' }}>
                       <Typography variant="caption" fontWeight="bold" sx={{ color: '#7b1fa2', display: 'block', mb: 1.5 }}>
                         Per Question Results ({count} Question{count !== 1 ? 's' : ''})
                       </Typography>
                       {Array.from({ length: count }).map((_, qi) => {
                         const ans = codingAnswers[qi] || {};
                         const qr  = perQ[qi] || {};
                         const tcs = qr.testCaseResults || [];
                         const tcPassed = tcs.filter(t => t.passed).length;
                         const tcTotal  = tcs.length;
                         const acc = tcTotal > 0 ? Math.round((tcPassed / tcTotal) * 100) : (qr.outputAccuracy ?? null);
                         return (
                           <Box key={qi} sx={{ mb: 2, border: '1px solid #ce93d8', borderRadius: 1, overflow: 'hidden' }}>
                             {/* Question header bar */}
                             <Box sx={{ px: 2, py: 1, bgcolor: '#7b1fa2', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                               <Typography variant="caption" fontWeight="bold" sx={{ color: '#fff', fontSize: '13px' }}>
                                 Question {qi + 1}
                               </Typography>
                               <Typography variant="caption" sx={{ color: '#e1bee7', fontWeight: 700 }}>
                                 Score: {qr.answerScore !== undefined ? `${qr.answerScore}/100` : '—'}
                               </Typography>
                             </Box>
                             <Box sx={{ p: 1.5, bgcolor: '#fce4ec' }}>
                               {/* Question text */}
                               {ans.question && (
                                 <Typography variant="caption" sx={{ display: 'block', color: '#4a0072', mb: 1.25, fontStyle: 'italic', lineHeight: 1.5, borderLeft: '3px solid #ce93d8', pl: 1 }}>
                                   {ans.question.length > 300 ? ans.question.slice(0, 300) + '…' : ans.question}
                                 </Typography>
                               )}
                               {/* Stats row */}
                               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1 }}>
                                 <Box sx={{ minWidth: 110 }}>
                                   <Typography variant="caption" color="text.secondary">Compilation</Typography>
                                   <Typography variant="body2" fontWeight="bold" sx={{ color: qr.compilationStatus === 'Passed' ? '#2e7d32' : qr.compilationStatus === 'Failed' ? '#c62828' : 'inherit' }}>
                                     {qr.compilationStatus || '—'}
                                   </Typography>
                                 </Box>
                                 <Box sx={{ minWidth: 130 }}>
                                   <Typography variant="caption" color="text.secondary">Test Cases</Typography>
                                   <Typography variant="body2" fontWeight="bold">
                                     {tcTotal > 0 ? `${tcPassed} / ${tcTotal} Passed` : 'N/A'}
                                   </Typography>
                                 </Box>
                                 <Box sx={{ minWidth: 150 }}>
                                   <Typography variant="caption" color="text.secondary">Output Accuracy</Typography>
                                   <Typography variant="body2" fontWeight="bold">
                                     {acc !== null && acc !== undefined ? `${acc}%` : 'Evaluation N/A'}
                                   </Typography>
                                 </Box>
                                 <Box sx={{ minWidth: 100 }}>
                                   <Typography variant="caption" color="text.secondary">Language</Typography>
                                   <Typography variant="body2" fontWeight="bold">{ans.selectedLanguage || '—'}</Typography>
                                 </Box>
                               </Box>
                               {/* Execution output (when no test cases) */}
                               {tcTotal === 0 && ans.terminalOutput && (
                                 <Box sx={{ mb: 1 }}>
                                   <Typography variant="caption" color="text.secondary">Terminal Output</Typography>
                                   <Box component="pre" sx={{ m: 0, mt: 0.5, p: 0.75, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 0.5, fontSize: '11px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: 100, overflowY: 'auto' }}>
                                     {ans.terminalOutput}
                                   </Box>
                                 </Box>
                               )}
                               {/* Test case details */}
                               {tcs.length > 0 && (
                                 <Box sx={{ mt: 1 }}>
                                   {tcs.map((tc, ti) => (
                                     <Box key={ti} sx={{ mb: 1, p: 1, bgcolor: tc.passed ? '#e8f5e9' : '#ffebee', borderRadius: 1, border: `1px solid ${tc.passed ? '#a5d6a7' : '#ef9a9a'}` }}>
                                       <Typography variant="caption" fontWeight="bold" sx={{ color: tc.passed ? '#2e7d32' : '#c62828' }}>
                                         Test Case {ti + 1}: {tc.passed ? '✓ Passed' : '✗ Failed'}
                                       </Typography>
                                       <Box sx={{ display: 'grid', gridTemplateColumns: tc.input != null && tc.input !== '' ? '1fr 1fr 1fr' : '1fr 1fr', gap: 1, mt: 0.5 }}>
                                         {tc.input != null && tc.input !== '' && (
                                           <Box>
                                             <Typography variant="caption" color="text.secondary">Input</Typography>
                                             <Box component="pre" sx={{ m: 0, p: 0.5, bgcolor: '#f5f5f5', borderRadius: 0.5, fontSize: '11px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{tc.input}</Box>
                                           </Box>
                                         )}
                                         <Box>
                                           <Typography variant="caption" color="text.secondary">Expected Output</Typography>
                                           <Box component="pre" sx={{ m: 0, p: 0.5, bgcolor: '#f5f5f5', borderRadius: 0.5, fontSize: '11px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{tc.expectedOutput || '(empty)'}</Box>
                                         </Box>
                                         <Box>
                                           <Typography variant="caption" color="text.secondary">Actual Output</Typography>
                                           <Box component="pre" sx={{ m: 0, p: 0.5, bgcolor: '#f5f5f5', borderRadius: 0.5, fontSize: '11px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all', color: tc.passed ? '#2e7d32' : '#c62828' }}>{tc.actualOutput || '(no output)'}</Box>
                                         </Box>
                                       </Box>
                                     </Box>
                                   ))}
                                 </Box>
                               )}
                             </Box>
                           </Box>
                         );
                       })}
                     </Box>
                   );
                 })()}
               </Box>
             )}



             {/* Architecture Assessment */}
             {ev.architectureEvaluation && (
               <Box sx={{ mb: 2, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #a5d6a7', borderLeft: '5px solid #2e7d32' }}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                   <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#2e7d32' }}>Architecture Assessment</Typography>
                   <Chip label={`Score: ${ev.architectureEvaluation.score}/100`} size="small"
                     sx={{ fontWeight: 700, bgcolor: '#2e7d32', color: '#fff', fontSize: '0.75rem' }} />
                 </Box>

                 {/* Architecture Drawing Preview */}
                 {(() => {
                   const img = aiCodingData?.architecture_canvas?.canvasImage ||
                     (() => {
                       try {
                         const ac = typeof aiCodingData?.architecture_canvas === 'string'
                           ? JSON.parse(aiCodingData.architecture_canvas)
                           : aiCodingData?.architecture_canvas;
                         return ac?.canvasImage;
                       } catch (e) { return null; }
                     })();
                   if (!img) return null;
                   return (
                     <Box sx={{ mb: 1.5 }}>
                       <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>Drawing Preview</Typography>
                       <Box component="img" src={img} alt="Architecture Drawing"
                         sx={{ width: '100%', maxWidth: 480, display: 'block', borderRadius: 1, border: '1px solid #c8e6c9', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} />
                     </Box>
                   );
                 })()}

                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                   {[
                     { label: 'System Thinking',     value: `${ev.architectureEvaluation.systemThinking}/10` },
                     { label: 'Scalability',          value: `${ev.architectureEvaluation.scalabilityUnderstanding}/10` },
                     { label: 'Completeness',         value: `${ev.architectureEvaluation.architectureCompleteness}/10` },
                     { label: 'Security Awareness',   value: `${ev.architectureEvaluation.securityAwareness}/10` },
                     { label: 'Fault Tolerance',      value: `${ev.architectureEvaluation.faultTolerance}/10` },
                     { label: 'Design Quality',       value: `${ev.architectureEvaluation.designQuality}/10` },
                     { label: 'Components',           value: ev.architectureEvaluation.componentCount },
                     { label: 'Connections',          value: ev.architectureEvaluation.connectionCount },
                   ].map(item => (
                     <Box key={item.label} sx={{ minWidth: 130 }}>
                       <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                       <Typography variant="body2" fontWeight="bold">{item.value}</Typography>
                     </Box>
                   ))}
                 </Box>
               </Box>
             )}

             {/* Q&A / Communication details */}
             {ev.qaEvaluation && (
               <Box sx={{ mb: 2, p: 2, bgcolor: '#e3f2fd', borderRadius: 2, border: '1px solid #90caf9', borderLeft: '5px solid #1976d2' }}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                   <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#1976d2' }}>Q&A Evaluation</Typography>
                   <Chip label={`Score: ${ev.qaEvaluation.score}/100`} size="small"
                     sx={{ fontWeight: 700, bgcolor: '#1976d2', color: '#fff', fontSize: '0.75rem' }} />
                 </Box>
                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                   {[
                     { label: 'Accuracy',         value: `${ev.qaEvaluation.accuracyScore}%` },
                     { label: 'Communication',    value: `${ev.qaEvaluation.communicationScore}%` },
                     { label: 'Technical Depth',  value: `${ev.qaEvaluation.technicalDepthScore}%` },
                     { label: 'Completeness',     value: `${ev.qaEvaluation.completenessScore}%` },
                     { label: 'Answered',         value: `${ev.qaEvaluation.answeredCount} / ${ev.qaEvaluation.questionsCount}` },
                   ].map(item => (
                     <Box key={item.label} sx={{ minWidth: 130 }}>
                       <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                       <Typography variant="body2" fontWeight="bold">{item.value}</Typography>
                     </Box>
                   ))}
                 </Box>
               </Box>
             )}
           </>
         );
       })()}

       {/* AI Feedback Summary Section */}
       <Box
         sx={{
           mb: 3,
           p: 2,
           bgcolor: `${aiCodingData.status_color || '#e0e0e0'}10`,
           borderRadius: 1,
           border: `1px solid ${aiCodingData.status_color || '#e0e0e0'}`,
           borderLeft: `6px solid ${aiCodingData.status_color || '#1976d2'}`
         }}
       >
         <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
           <Typography
             variant="subtitle2"
             fontWeight="bold"
             sx={{
               color: aiCodingData.status_color || 'text.primary',
               textTransform: 'none',
               letterSpacing: '0.5px'
             }}
           >
             {isTerminated ? "Termination Note:" : "Performance Assessment:"}
           </Typography>
         </Box>

         <Typography
           variant="body2"
           sx={{
             color: 'text.primary',
             lineHeight: 1.6,
             fontWeight: 500
           }}
         >
           {(() => {
              let f = aiCodingData.feedback || "No assessment data available for this session.";
              return f.replace(/^TERMINATED:\s*/i, '');
           })()}
         </Typography>
       </Box>

       {/* Behavioral Analysis Section */}
       {aiCodingData.behavior_summary && (
         <Box
           sx={{
             mb: 3,
             p: 2,
             bgcolor: '#f4f8ff',
             borderRadius: 1,
             border: '1px solid #d1e3ff',
             borderLeft: '6px solid #1976d2'
           }}
         >
           <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
             <Typography
               variant="subtitle2"
               fontWeight="bold"
               sx={{
                 color: '#1976d2',
                 textTransform: 'none',
                 letterSpacing: '0.5px'
               }}
             >
               Behavioral Analysis:
             </Typography>
           </Box>

           <Typography
             variant="body2"
             sx={{
               color: 'text.primary',
               lineHeight: 1.6,
               fontWeight: 500,
               mb: 1
             }}
           >
             <strong>Confidence:</strong> {(() => {
               const summary = typeof aiCodingData.behavior_summary === 'string'
                 ? JSON.parse(aiCodingData.behavior_summary)
                 : aiCodingData.behavior_summary;
               return summary.confidence || 'N/A';
             })()}
           </Typography>

           {(() => {
             const summary = typeof aiCodingData.behavior_summary === 'string'
               ? JSON.parse(aiCodingData.behavior_summary)
               : aiCodingData.behavior_summary;
             const observations = summary.observations || [];
             if (observations.length === 0) return null;
             return observations.map((obs, i) => (
               <Typography key={i} variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                 • {obs}
               </Typography>
             ));
           })()}
         </Box>
       )}

       {/* Trust Assessment Section */}
       {aiCodingData.trust_score !== undefined && (
         <Box
           sx={{
             mb: 3,
             p: 2,
             bgcolor: aiCodingData.risk_level === 'LOW' ? '#d4edda20' : aiCodingData.risk_level === 'MEDIUM' ? '#fff3cd20' : '#f8d7da20',
             borderRadius: 1,
             border: `1px solid ${aiCodingData.risk_level === 'LOW' ? '#d4edda' : aiCodingData.risk_level === 'MEDIUM' ? '#fff3cd' : '#f8d7da'}`,
             borderLeft: `6px solid ${aiCodingData.risk_level === 'LOW' ? '#28a745' : aiCodingData.risk_level === 'MEDIUM' ? '#ffc107' : '#dc3545'}`
           }}
         >
           <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
             <Typography
               variant="subtitle2"
               fontWeight="bold"
               sx={{
                 color: aiCodingData.risk_level === 'LOW' ? '#155724' : aiCodingData.risk_level === 'MEDIUM' ? '#856404' : '#721c24',
                 textTransform: 'none',
                 letterSpacing: '0.5px'
               }}
             >
               Trust Assessment:
             </Typography>
           </Box>

           <Typography
             variant="body2"
             sx={{
               color: 'text.primary',
               lineHeight: 1.6,
               fontWeight: 500
             }}
           >
             <strong>{(aiCodingData.risk_level || 'LOW').toUpperCase()} RISK</strong>
             {(() => {
               let allViolations = [];

               try {
                 const v = typeof aiCodingData.violations === "string"
                   ? JSON.parse(aiCodingData.violations)
                   : aiCodingData.violations || {};

                 allViolations = Object.entries(v)
                   .filter(([_, count]) => count > 0)
                   .map(([key]) => getLabel(key));

               } catch (e) {
                 console.error("Violation parse error", e);
               }

               return allViolations.length > 0
                 ? ` – ${allViolations.join(", ")}`
                 : "";
             })()}
           </Typography>
         </Box>
       )}

       {/* Suspicious Activity Timeline */}
       {aiCodingData.violation_events && (
         <Box
           sx={{
             mt: 2,
             mb: 3,
             border: "1px solid #e0e0e0",
             backgroundColor: "#fafafa",
             p: 2,
             borderRadius: "10px"
           }}
         >
           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
             Suspicious Activity Timeline
           </Typography>

           {(() => {
             const events = aiCodingData.violation_events || [];
             if (events.length === 0) {
               return (
                 <Typography variant="body2" color="text.secondary">
                   No suspicious activity detected.
                 </Typography>
               );
             }
             return events.map((event, i) => (
               <Box
                 key={i}
                 sx={{
                   display: "flex",
                   justifyContent: "space-between",
                   alignItems: "center",
                   mt: 1,
                   p: 1.2,
                   borderRadius: "6px",
                   backgroundColor: "#ffffff",
                   border: "1px solid #f0f0f0",
                   cursor: "pointer",
                   transition: "0.2s",
                   '&:hover': {
                     backgroundColor: "#f5f5f5",
                     borderColor: "#e0e0e0"
                   }
                 }}
                 onClick={() => handleJump(event.time)}
               >
                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
                   <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary', minWidth: '50px' }}>
                     [{formatTime(event.time)}]
                   </Typography>
                   <Typography
                     variant="body2"
                     sx={{
                       ml: 2,
                       color: getSeverityColor(event.type),
                       fontWeight: 500
                     }}
                   >
                     {getLabel(event.type)}
                   </Typography>
                 </Box>
                 <Chip
                   label={getSeverityLabel(event.type)}
                   size="small"
                   sx={{
                     ml: 1,
                     fontSize: '0.75rem',
                     fontWeight: 600,
                     backgroundColor: `${getSeverityColor(event.type)}15`,
                     color: getSeverityColor(event.type),
                     border: `1px solid ${getSeverityColor(event.type)}30`,
                   }}
                 />
               </Box>
             ));
           })()}
         </Box>
       )}

       {/* Transcript Section */}
       {answers.length > 0 ? (
         <>
           <Typography
             variant="h6"

             sx={{
               color: 'black', // Dark teal color to match Performance Assessment
               mb: 1.5,
               mt: 2,
               textTransform: 'none' // Ensures it matches your preferred casing
             }}
           >
             Interview Transcript
           </Typography>
           <Box sx={{ maxHeight: '350px', overflowY: 'auto', pr: 1 }}>
             {answers.map((item, index) => (
               <Box key={index} sx={{ mb: 2, p: 1.5, bgcolor: '#f9f9f9', borderRadius: 1, border: '1px solid #f0f0f0' }}>
                 <Typography variant="body2" fontWeight="bold" color="primary">Question {index + 1}: {item.question}</Typography>
                 <Typography variant="body2" sx={{ mt: 1, color: (item.answer === "No response" || !item.answer) ? 'error.main' : 'text.primary', textTransform: 'none !important', }}>
                   <strong>Answer:</strong>
                   {item.questionType === 'coding' ? (
                     (() => {
                       const isFrontend = /html\/css|html|frontend/i.test(item.selectedLanguage || '');
                       if (isFrontend) {
                         const src = item.sourceCode || item.answer || '';
                         const htmlMatch = src.match(/<!--\s*HTML\s*-->\n([\s\S]*?)(?=\n\s*\/\*\s*CSS|$)/);
                         const cssMatch  = src.match(/\/\*\s*CSS\s*\*\/\n([\s\S]*)/);
                         const htmlCode  = htmlMatch ? htmlMatch[1].trim() : src;
                         const cssCode   = cssMatch  ? cssMatch[1].trim()  : '';
                         // Use the captured snapshot if available, otherwise reconstruct
                         const srcdoc    = item.frontendSnapshot || `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>*{box-sizing:border-box;}${cssCode}</style></head><body>${htmlCode}</body></html>`;
                         return (
                           <Box sx={{ mt: 1 }}>
                             <Typography variant="caption" display="block" sx={{ color: '#888', mb: 0.75 }}>
                               Language: <strong>HTML/CSS (Frontend)</strong>
                             </Typography>
                             {/* Live rendered preview */}
                             <Box sx={{ mb: 1.5, border: '1px solid #e2e8f0', borderRadius: 1, overflow: 'hidden' }}>
                               <Box sx={{ px: 1.5, py: 0.6, bgcolor: '#f8faff', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                 <Box sx={{ display: 'flex', gap: 0.5 }}>
                                   {['#ff5f57','#febc2e','#28c840'].map(c => (
                                     <Box key={c} sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: c }} />
                                   ))}
                                 </Box>
                                 <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.7rem', letterSpacing: '0.03em' }}>
                                   Live Preview
                                 </Typography>
                               </Box>
                               <iframe
                                 srcDoc={srcdoc}
                                 sandbox="allow-scripts"
                                 style={{ width: '100%', height: '280px', border: 'none', display: 'block', background: '#fff' }}
                                 title={`Frontend Preview - Q${index + 1}`}
                               />
                             </Box>
                             {/* Split source: HTML */}
                             {htmlCode && (
                               <Box sx={{ mb: 1 }}>
                                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#e34c26', display: 'block', mb: 0.4 }}>HTML</Typography>
                                 <Box sx={{ p: 1.5, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 1, overflowX: 'auto', border: '1px solid #333' }}>
                                   <pre style={{ margin: 0, fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>{htmlCode}</pre>
                                 </Box>
                               </Box>
                             )}
                             {/* Split source: CSS */}
                             {cssCode && (
                               <Box sx={{ mb: 1 }}>
                                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#264de4', display: 'block', mb: 0.4 }}>CSS</Typography>
                                 <Box sx={{ p: 1.5, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 1, overflowX: 'auto', border: '1px solid #333' }}>
                                   <pre style={{ margin: 0, fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>{cssCode}</pre>
                                 </Box>
                               </Box>
                             )}
                           </Box>
                         );
                       }
                       // Non-frontend coding question — original rendering
                       return (
                         <Box sx={{ mt: 1 }}>
                           <Typography variant="caption" display="block" color="text.secondary">Language: {item.selectedLanguage || 'Unknown'}</Typography>
                           <Box sx={{ mt: 0.5, p: 1.5, bgcolor: '#1e1e1e', color: '#d4d4d4', borderRadius: 1, overflowX: 'auto', border: '1px solid #333' }}>
                             <pre style={{ margin: 0, fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '0.875rem', overflowX: 'auto' }}>
                               <code>{item.sourceCode || item.answer || item.response}</code>
                             </pre>
                           </Box>
                           {(item.executionOutput || item.compileError || item.runtimeError || item.terminalOutput || item.executionStatus) && (
                             <Box sx={{ mt: 1.5 }}>
                               <Typography variant="caption" fontWeight="bold" sx={{ color: '#555', mb: 0.5, display: 'block' }}>Terminal Output:</Typography>
                               <Box sx={{ p: 1.5, bgcolor: '#000', color: '#00ff00', borderRadius: 1, fontFamily: 'monospace', fontSize: '0.8rem', border: '1px solid #333', maxHeight: '200px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
                                 {item.terminalOutput || (
                                   <>
                                     {item.compileError && `Compilation failed:\n${item.compileError}\n\n`}
                                     {item.runtimeError && `Runtime Error:\n${item.runtimeError}\n\n`}
                                     {item.executionOutput && `${item.executionOutput}\n`}
                                     {!item.compileError && !item.runtimeError && !item.executionOutput && "No output recorded"}
                                   </>
                                 )}
                               </Box>
                               <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                 <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555' }}>Status:</Typography>
                                 <Chip
                                   label={item.executionStatus === 'success' ? 'Execution Successful' : item.executionStatus === 'compile_error' ? 'Compilation Failed' : item.executionStatus === 'runtime_error' ? 'Runtime Error' : item.executionStatus === 'not_executed' ? 'Not Executed' : item.executionStatus || 'Unknown'}
                                   size="small" color={item.executionStatus === 'success' ? 'success' : 'error'} variant="outlined"
                                   sx={{ height: '20px', fontSize: '0.7rem' }}
                                 />
                               </Box>
                             </Box>
                           )}
                         </Box>
                       );
                     })()
                   ) : item.questionType === 'architecture' ? (
                     <Box sx={{ mt: 1 }}>
                       <Typography variant="caption" display="block" sx={{ color: '#4F46E5', fontWeight: 700, mb: 1 }}>
                         Architecture Canvas Submission
                       </Typography>
                       {(() => {
                         const img = item.canvasData?.canvasImage || aiCodingData?.architecture_canvas?.canvasImage;
                         const count = item.canvasData?.shapes?.length || aiCodingData?.architecture_canvas?.shapes?.length || 0;
                         if (img) {
                           return (
                             <Box>
                               <Box
                                 component="img"
                                 src={img}
                                 alt="Architecture Drawing"
                                 sx={{ width: '100%', maxWidth: 640, display: 'block', borderRadius: 1, border: '1px solid #ddd', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                               />
                               {count > 0 && (
                                 <Typography variant="caption" display="block" sx={{ mt: 0.5, color: '#666' }}>
                                   {count} component{count !== 1 ? 's' : ''} placed on canvas
                                 </Typography>
                               )}
                             </Box>
                           );
                         }
                         return (
                           <Typography variant="body2" color="text.secondary">
                             Architecture drawing submitted ({count} component{count !== 1 ? 's' : ''} placed)
                           </Typography>
                         );
                       })()}
                     </Box>
                   ) : (
                     <span style={{ whiteSpace: 'pre-wrap' }}>{item.answer || item.response || "No response recorded"}</span>
                   )}
                 </Typography>
               </Box>
             ))}
           </Box>
         </>
       ) : (
         !isTerminated && <Typography variant="caption" color="text.secondary">Detailed transcript is being processed...</Typography>
       )}
     </Paper>
     </>
   );
 };
  const renderAssessmentSection = (title, data, icon) => {
    if (!data) return null;

    // Check if it's completed or has feedback
    const isCompleted = data.completed_at || data.completedAt;
    if (!isCompleted && !data.feedback && !data.notes) return null;

    const feedbackObj = parseAIFeedback(data.notes || data.feedback);

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: '#fcfcfc' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
            <Box sx={{ color: 'primary.main', mr: 1, display: 'flex' }}>{icon}</Box>
            <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
          </Box>
          <Divider sx={{ mb: 1.5 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">Score:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {data.score !== undefined ? `${data.score} / ${data.max_score || 100}` : 'N/A'}
              </Typography>
            </Box>

            {feedbackObj && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2" color="text.secondary" gutterBottom>AI Feedback Report:</Typography>
                  <Box sx={{ p: 1.5, bgcolor: '#f0f4f8', borderRadius: 1, borderLeft: '4px solid #1976d2' }}>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                      {feedbackObj.detailedFeedback || feedbackObj.feedback || (typeof feedbackObj === 'string' ? feedbackObj : 'No detailed feedback available.')}
                    </Typography>
                    {feedbackObj.strengths && (
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="caption" fontWeight="bold" color="success.main">Strengths:</Typography>
                          <Typography variant="caption" display="block">{feedbackObj.strengths}</Typography>
                        </Box>
                    )}
                    {feedbackObj.weaknesses && (
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="caption" fontWeight="bold" color="error.main">Areas for Improvement:</Typography>
                          <Typography variant="caption" display="block">{feedbackObj.weaknesses}</Typography>
                        </Box>
                    )}
                  </Box>
                </Box>
            )}

            {title === 'Coding Test' && (data.selected_language || data.candidate_code) && (
              <Box sx={{ mt: 2 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => navigate(`/admin/applications/${selectedApp?.id}`)}
                >
                  View Code Details
                </Button>
              </Box>
            )}
          </Box>
        </Paper>
    );
  };


  const filteredInterviews = Array.isArray(interviews) ? interviews.filter(app => {
    const fullName = `${app.first_name} ${app.last_name}`.toLowerCase();
    const email = (app.email || '').toLowerCase();
    const jobTitle = (app.job_title || '').toLowerCase();
    const status = (app.status || '').toLowerCase();
    const query = searchQuery.toLowerCase();

    const matchesSearch = fullName.includes(query) || email.includes(query) || jobTitle.includes(query) || status.includes(query);
    const filterMap = {
      'Technical Interview Cancelled': 'technical_cancelled',
      'HR Interview Cancelled': 'hr_cancelled',

    };

    const normalizedFilter =
      filterMap[statusFilter] ||
      statusFilter.toLowerCase().replace(/\s+/g, '_');

    const matchesStatus =
      statusFilter === 'All' ||
      status.includes(normalizedFilter);

    return matchesSearch && matchesStatus;
  }) : [];

  const totalPages = Math.ceil(filteredInterviews.length / INTERVIEWS_PER_PAGE);

  const paginatedInterviews = filteredInterviews.slice(
    (page - 1) * INTERVIEWS_PER_PAGE,
    page * INTERVIEWS_PER_PAGE
  );

  return (
      <Container maxWidth="xl" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Typography variant="h4"
                        sx={{
                          color: "#4F46E5",
                          fontWeight: "bold",
                          mb: 0.5
                        }}
            >
              Interviews
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage and review AI interviews
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              size="small"
              placeholder="Search by name, email, role or status..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                width: 350,
                bgcolor: 'white',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="outlined"
              startIcon={<FilterList />}
              onClick={handleFilterClick}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 'bold',
                color: '#4F46E5',
                borderColor: '#4F46E5',
                height: '40px',
                '&:hover': {
                   borderColor: '#4338CA',
                   bgcolor: 'rgba(79, 70, 229, 0.04)'
                }
              }}
            >
              {statusFilter === 'All' ? 'Filters' : `Status: ${statusFilter}`}
            </Button>
            <Menu
              anchorEl={filterAnchorEl}
              open={Boolean(filterAnchorEl)}
              onClose={handleFilterClose}
            >
              {[
                 'All',
                 'Pending',
                 'Shortlisted',
                 'Selected',
                 'Offer Released',
                 'Rejected',
                 'Terminated',
                 'Completed',
                 'Interview Scheduled',
                 'Technical Interview Cancelled',
                 'HR Interview Cancelled',
               ].map((status) => (
                <MenuItem key={status} onClick={() => handleFilterSelect(status)}>
                  {status}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>

        {!Array.isArray(interviews) || interviews.length === 0 ? (
            <Paper sx={{ p: 8, textAlign: 'center', borderRadius: 4, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
              <Feedback sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6" color="text.secondary">
                No interview history found.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Applications that have completed assessments will appear here.
              </Typography>
            </Paper>
        ) : (
        <>
            <TableContainer component={Paper} sx={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
              <Table>
                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Candidate Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Email</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Job Title</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2 }}>
                      Score
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#111827', py: 2, textAlign: 'center' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedInterviews.map((app) => {
                    const statusProps = getStatusBadgeProps(app.status);
                    return (
                      <TableRow key={app.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar sx={{
                              bgcolor: getAvatarColor(app.first_name),
                              width: 36,
                              height: 36,
                              mr: 2,
                              fontSize: '0.9rem',
                              fontWeight: 600
                            }}>
                              {getInitials(app.first_name, app.last_name)}
                            </Avatar>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827' }}>
                              {app.first_name} {app.last_name}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ color: '#111827' }}>
                            {app.email}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Work sx={{ fontSize: 18, mr: 1, color: '#111827' }} />
                            <Typography variant="body2" sx={{ color: '#111827' }}>
                              {app.job_title || 'Software Developer'}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                           <Box sx={{
                             display: 'inline-flex',
                             alignItems: 'center',
                             bgcolor: statusProps.bgcolor,
                             px: 1.5,
                             py: 0.5,
                             borderRadius: '6px',
                             border: `1px solid ${statusProps.border}`
                           }}>
                              <Typography variant="caption" sx={{ color: statusProps.color, fontWeight: 700 }}>
                                {statusProps.label}
                              </Typography>
                           </Box>
                        </TableCell>
                        <TableCell>
                          {app.ai_score !== null &&
                           app.ai_score !== undefined ? (
                            <Chip
                              label={`${app.ai_score}%`}
                              size="small"
                              color={
                                Number(app.ai_score) >= 70
                                  ? "success"
                                  : Number(app.ai_score) >= 40
                                  ? "warning"
                                  : "error"
                              }
                            />
                          ) : (
                            <Chip
                              label="Not available"
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>
                          <Button
                              variant="outlined"
                              size="small"
                              startIcon={<Visibility sx={{ fontSize: 16 }} />}
                              onClick={() => handleOpenDetails(app)}
                              sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                color: '#4F46E5',
                                borderColor: '#4F46E5',
                                '&:hover': {
                                   bgcolor: 'rgba(79, 70, 229, 0.04)',
                                   borderColor: '#4338CA'
                                }
                              }}
                          >
                            View AI Report
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  Showing {(page - 1) * INTERVIEWS_PER_PAGE + 1} to {Math.min(page * INTERVIEWS_PER_PAGE, filteredInterviews.length)} of {filteredInterviews.length} interviews
                </Typography>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  shape="rounded"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      borderRadius: '4px',
                      fontWeight: 600
                    },
                    '& .Mui-selected': {
                      bgcolor: '#4338CA !important',
                      color: 'white'
                    }
                  }}
                />
              </Box>
            )}
            </>
        )}

        {/* Details Dialog */}
        <Dialog
            open={detailsDialogOpen}
            onClose={handleCloseDetails}
            maxWidth="md"
            fullWidth
            scroll="paper"
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold">Interview Report</Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Applicant: {selectedApp?.first_name} {selectedApp?.last_name} | Job: {selectedApp?.job_title}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<Download />}
                          onClick={handleDownloadPDF}
                          disabled={!aiCodingData}
                          sx={{
                                  textTransform: 'none',
                                  fontWeight: 'bold',
                                  borderRadius: 1.5
                                }}
                        >
                          DOWNLOAD REPORT
                        </Button>
            <Chip
              label={getStageLabel(selectedApp?.status)}
              color={getStatusColor(selectedApp?.status)}
            />
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            {/* --- CRITICAL: Added ID for PDF Capture --- */}
                <Box id="report-to-download" sx={{ p: 1, bgcolor: 'white' }}>
                  <Typography variant="h6" sx={{ color: '#4F46E5', mb: 2, fontWeight: 'bold' }}>
                    Assessment Feedback
                  </Typography>
                {/* --- AI INTERVIEW REPORTS --- */}
                {aiDataLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size={28} sx={{ color: '#4F46E5' }} />
                  </Box>
                ) : (
                  <>
                    {/* AI Coding Interview Assessment */}
                    {aiCodingData
                      ? renderAiTranscriptSection(aiCodingData, 'AI Coding Interview Assessment')
                      : null}

                    {/* AI Technical Interview Assessment */}
                    {aiTechnicalData
                      ? renderAiTranscriptSection(aiTechnicalData, 'AI Technical Interview Assessment')
                      : null}

                    {/* AI HR Interview Assessment */}
                    {aiHrData
                      ? renderAiTranscriptSection(aiHrData, 'AI HR Interview Assessment')
                      : null}

                    {/* Fallback message when no section has data */}
                    {!aiCodingData && !aiTechnicalData && !aiHrData && (
                      <Paper variant="outlined" sx={{ p: 3, mb: 3, bgcolor: '#f9f9f9', textAlign: 'center', borderRadius: 2 }}>
                        <Typography color="text.secondary">
                          No AI interview report available for this candidate.
                        </Typography>
                      </Paper>
                    )}
                  </>
                )}

                {/* --- EXISTING SECTIONS (KEPT EXACTLY THE SAME) --- */}
                {renderAssessmentSection('Coding Test', selectedApp?.codingTest, <Code />)}
                {/* Show simple sections only when no rich AI report exists for that type */}
                {!aiTechnicalData && renderAssessmentSection('Technical Interview', selectedApp?.technicalInterview, <Psychology />)}
                {!aiHrData && renderAssessmentSection('HR Interview', selectedApp?.hrInterview, <Group />)}
                {/* HIDDEN PRINT-ONLY TEMPLATE */}
                 {renderPDFTemplate()}
                </Box>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDetails}>Close</Button>
            <Button
                variant="contained"
                onClick={() => navigate(`/admin/applications/${selectedApp?.id}`)}
            >
              Go to Application
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
  );
}

export default JobInterviewHistory;
